import { outreach } from '@round/api';
import { Tabs } from '@round/creatorbase-ui';
import { getTabItems, OutreachResultsTab, parseTab } from './helpers';
import styles from './OutreachResultsTabs.module.css';

type Props = {
    request: outreach.OutreachRequest;
    value: OutreachResultsTab;
    onChange: (tab: OutreachResultsTab) => void;
};

export const OutreachResultsTabs = ({ request, value, onChange }: Props) => (
    <Tabs value={value} onValueChange={(tab) => onChange(parseTab(tab))}>
        <Tabs.List variant="line" aria-label="Result status">
            {getTabItems(request).map((tab) => (
                <Tabs.Trigger key={tab.value} value={tab.value}>
                    {tab.label}
                    <span className={styles.count}>{tab.count}</span>
                </Tabs.Trigger>
            ))}
        </Tabs.List>
    </Tabs>
);
